function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var e = function e(o, C, t) {
  return C in o ? l(o, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[C] = t;
},
    i = function i(o, C) {
  for (var t in C || (C = {})) {
    w.call(C, t) && e(o, t, C[t]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        g.call(C, t) && e(o, t, C[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as r from "react";

function p(o) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), r.createElement("path", {
    d: "M17.8233 22.1141C16.6014 23.2721 15.2531 23.0916 13.968 22.5456C12.6018 21.9886 11.3527 21.9533 9.90981 22.5456C8.11293 23.303 7.15925 23.0828 6.07706 22.1141C-0.0328034 15.9714 0.869021 6.61427 7.81307 6.262C9.49723 6.35007 10.6764 7.1713 11.6684 7.23955C13.1429 6.94672 14.5542 6.10789 16.1324 6.21797C18.0285 6.36768 19.4466 7.09864 20.3935 8.41304C16.4931 10.7028 17.4175 15.7226 21 17.1317C20.2831 18.9701 19.3632 20.7865 17.8211 22.1295L17.8233 22.1141ZM11.5331 6.19595C11.3505 3.46588 13.6163 1.22017 16.2226 1C16.5811 4.1484 13.2917 6.50419 11.5331 6.19595Z",
    fill: "black"
  }));
}

export { p as ReactComponent };